import React from 'react';
import Head from 'next/head';
import { Box, Container } from '@mui/material';
import AboutLayout from '../../../src/components/about/AboutLayout';
import ViceAndVirtuMain from '../../../src/components/about/viceandvirtue/ViceAndVirtueMain';

function ViceAndVirtueIndex() {
  return (
    <>
      <Head>
        <title>
          Vice and Virtue Index™ - About Vice and Virtue Index - About
          blockquiry
        </title>
        <meta
          name="description"
          content="blockquiry's Crypto Vice & Virtue Index is used to gauge the trust of the crypto 
          community in the overall viability, safety, and security of the crypto ecosystem. 
          Crypto Vice & Virtue Index breaks down further into Crypto Exchanges Vice and Virtue Index, 
          Crypto DEX Vice and Virtue Index, and Crypto Protocol Vice and Virtue Index. "
        />
        <meta
          name="og:description"
          content="blockquiry's Crypto Vice & Virtue Index is a way to gauge blockchain security and 
          safety and whether users' sentiment corresponds to actual blockchain performance."
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Box />

      <Container disableGutters maxWidth="lg">
        <ViceAndVirtuMain />
      </Container>
    </>
  );
}

ViceAndVirtueIndex.getLayout = function getLayout(page) {
  return <AboutLayout>{page}</AboutLayout>;
};

export default ViceAndVirtueIndex;
